import React from 'react';
import ContactInfo from '../common/ContactInfo';

export default function ContactForm() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
        Get in Touch
      </h2>
      <ContactInfo />
    </div>
  );
}